import React from 'react';
import NewTableContext from './NewTableContext';

const NewTableContextProvider = ({
    children,
}: React.PropsWithChildren<object>) => {
    const [isNewTable, setIsNewTable] = React.useState(false);
    return (
        <NewTableContext.Provider value={{ isNewTable, setIsNewTable }}>
            {children}
        </NewTableContext.Provider>
    );
};

export default NewTableContextProvider;
